'use strict'

import HashManager from 'assets/core/js/module/hashManager'

export const openSection = (target: string): void => {
  const titleEl = document.querySelector<HTMLElement>('.product__section-title-block[data-target="' + target + '"]')

  if (titleEl) {
    if ((titleEl.parentNode as HTMLElement).classList.contains('dca-collapsible-block--collapsed')) {
      titleEl.click()
    }
  }
}

export default function (): void {
  if ('IntersectionObserver' in window) {
    const productNavigationEl = document.getElementById('productNavigation')

    const navigationItemsObserver = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            document.querySelector('.navigation__item.navigation--active')?.classList.remove('navigation--active')
            document.querySelector('.navigation__item[href="#' + entry.target.getAttribute('id') + '"]')?.classList.add('navigation--active')
          }
        })
      },
      {
        rootMargin: '-25% 0% -65% 0%',
      }
    )

    document.querySelectorAll<HTMLElement>('.product__navigation .navigation__item').forEach((item) => {
      const target = item.getAttribute('href')?.replace('#', '')

      if (!target) {
        return
      }

      const targetEl = document.getElementById(target)
      const secondTarget = item.getAttribute('data-open')

      item.addEventListener('click', function (e) {
        e.preventDefault()
        HashManager.setAnchor(target)

        openSection(target)

        if (secondTarget) {
          openSection(secondTarget)
        }
      })

      if (targetEl) {
        navigationItemsObserver.observe(targetEl)
      }
    })

    const navigationObserver = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            productNavigationEl?.classList.remove('nav--sticky')
          } else {
            productNavigationEl?.classList.add('nav--sticky')
          }
        })
      },
      {
        rootMargin: '-40% 0% -40% 0%',
      }
    )

    navigationObserver.observe(document.querySelector<HTMLElement>('.product__content .product__images') as HTMLElement)
  }

  const reviewsLink = document.querySelector<HTMLElement>('.product__header .product__reviews .reviews__campings')
  if (HashManager.getAnchor() === 'reviews' && reviewsLink) {
    window.setTimeout(() => reviewsLink.click(), 0)
  }
}
